(() => {
  const SELECTOR = '.header__inline-menu header-menu > details';
  const CLOSE_DELAY = 140;

  const setOpen = (details, open) => {
    const summary = details.querySelector(':scope > summary');

    details.toggleAttribute('open', open);
    details.classList.remove('menu-opening');

    if (summary) summary.setAttribute('aria-expanded', String(open));
  };

  const closeAll = (root = document, except = null) => {
    const selector = root.matches?.('.header__inline-menu') ? 'header-menu > details' : SELECTOR;

    root.querySelectorAll(selector).forEach((details) => {
      if (details !== except) setOpen(details, false);
    });
  };

  const initMenu = (root = document) => {
    const navs = root.querySelectorAll('.header__inline-menu');

    navs.forEach((nav) => {
      if (nav.dataset.ccMenuReady === 'true') return;

      const items = Array.from(nav.querySelectorAll('header-menu > details'));
      if (!items.length) return;

      nav.dataset.ccMenuReady = 'true';
      const supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      let closeTimer;

      const cancelClose = () => window.clearTimeout(closeTimer);
      const openItem = (details) => {
        cancelClose();
        items.forEach((item) => {
          if (item !== details) setOpen(item, false);
        });
        setOpen(details, true);
      };
      const scheduleClose = (details) => {
        cancelClose();
        closeTimer = window.setTimeout(() => setOpen(details, false), CLOSE_DELAY);
      };

      items.forEach((details) => {
        const summary = details.querySelector(':scope > summary');
        if (!summary) return;

        if (supportsHover) {
          summary.addEventListener('pointerenter', () => openItem(details));
          details.addEventListener('pointerenter', cancelClose);
          details.addEventListener('pointerleave', () => scheduleClose(details));
        }
      });

      nav.addEventListener('click', (event) => {
        if (event.target.closest('a[href]')) {
          window.setTimeout(() => closeAll(nav), 0);
        }
      });
    });
  };

  const resetAndInit = (root = document) => {
    closeAll(root);
    initMenu(root);
  };

  document.addEventListener('click', (event) => {
    if (!event.target.closest('.section-header')) closeAll();
  });

  document.addEventListener('DOMContentLoaded', () => resetAndInit());
  window.addEventListener('pageshow', () => resetAndInit());
  window.addEventListener('pagehide', () => closeAll());

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('.header__inline-menu').forEach((nav) => {
      delete nav.dataset.ccMenuReady;
    });
    resetAndInit(event.target);
  });
})();
